import { css } from 'styled-components';
import { HEADING_SIZES } from "../../components/type/constants.js";
var TEXT_STYLES = {
  FONT: 'font',
  FONT_FAMILY: 'font-family',
  FONT_SIZE: 'font-size',
  FONT_WEIGHT: 'font-weight',
  LETTER_SPACING: 'letter-spacing',
  LINE_HEIGHT: 'line-height'
};
var DEFAULTS = [TEXT_STYLES.FONT, TEXT_STYLES.LETTER_SPACING];
/**
 * @method bodyText()
 * @param {"x-small" | "small" | "medium" | "large"} size
 * (Required) the size of the BodyText you're trying to replicate.
 * @param {{isBold, options}} options - (Optional) defaults to {isBold: false,
 * ["font", "letter-spacing"]}.
 * @property {boolean} options.isBold - (Optional) returns style declarations
 * with bold or normal font-weight CSS variables.
 * @property {("font" | "font-family" | "font-size" | "font-weight" |
 * "letter-spacing" | "line-height")[]} options.styles - (Optional) returns
 * specific style declarations.
 *
 */
var bodyText = (size, options) => {
  var {
    isBold,
    styles = DEFAULTS
  } = options !== null && options !== void 0 ? options : {
    isBold: false,
    styles: DEFAULTS
  };
  if (!styles.length) return css([""]);
  return css(["", ""], styles === null || styles === void 0 ? void 0 : styles.map(style => {
    if (style === TEXT_STYLES.FONT && isBold) return css(["", ":var(--body-text-", ");", ":var(--body-text-bold-", ");"], style, size, TEXT_STYLES.FONT_WEIGHT, TEXT_STYLES.FONT_WEIGHT);
    if (style === TEXT_STYLES.FONT) return css(["", ":var(--body-text-", ");", ":var(--body-text-normal-", ");"], style, size, TEXT_STYLES.FONT_WEIGHT, TEXT_STYLES.FONT_WEIGHT);
    if (style === TEXT_STYLES.FONT_WEIGHT && isBold) return css(["", ":var(--body-text-bold-", ");"], style, style);
    if (style === TEXT_STYLES.FONT_WEIGHT) return css(["", ":var(--body-text-normal-", ");"], style, style);
    if (style === TEXT_STYLES.LETTER_SPACING) return css(["", ":var(--body-text-", ");"], style, style);
    return css(["", ":var(--body-text-", "-", ");"], style, style, size);
  }));
};

/**
 * Does not accept a `size` param because EyebrowText is only available in one
 * size. EyebrowText is always bold.
 * @method eyebrowText()
 * @param {{options}} options (Optional) defaults to {styles: ["font",
 * "letter-spacing"]}.
 * @property {("font" | "font-family" | "font-size" | "font-weight" |
 * "letter-spacing" | "line-height")[]} options.styles (Optional) returns
 * specific style declarations.
 *
 */
var eyebrowText = options => {
  var {
    styles = DEFAULTS
  } = options !== null && options !== void 0 ? options : {
    styles: DEFAULTS
  };
  if (!styles.length) return css([""]);
  return css(["", ""], styles.map(style => {
    if (style === TEXT_STYLES.FONT) return css(["", ":var(--eyebrow-text);text-transform:uppercase;"], style);
    return css(["", ":var(--eyebrow-text-", ");"], style, style);
  }));
};

/**
 * Headings are always bold.
 * @method heading()
 * @param {"xx-small" | "x-small" | "small" | "medium" | "large"} size
 * (Required) the size of the Heading you're trying to replicate.
 * @param {{options}} options - (Optional) defaults to {styles: ["font",
 * "letter-spacing"]}.
 * @property {("font" | "font-family" | "font-size" | "font-weight" |
 * "letter-spacing" | "line-height")[]} options.styles (Optional) returns
 * specific style declarations.
 *
 */
var heading = (size, options) => {
  var {
    styles = DEFAULTS
  } = options !== null && options !== void 0 ? options : {
    styles: DEFAULTS
  };
  if (!styles.length) return css([""]);
  return css(["", ""], styles.map(style => {
    if (style === TEXT_STYLES.FONT) return css(["", ":var(--heading-", ");"], style, size);
    if (style === TEXT_STYLES.FONT_WEIGHT && size === HEADING_SIZES.LARGE) return css(["", ":var(--extra-bold-", ");"], style, style);
    if (style === TEXT_STYLES.FONT_WEIGHT) return css(["", ":var(--heading-", ");"], style, style);
    return css(["", ":var(--heading-", "-", ");"], style, style, size);
  }));
};

/**
 * Returns styled-components CSS for replicating Heading, BodyText, and
 * EyebrowText. Each method has its own signature, and documentation.
 */
var getTextStyles = {
  bodyText,
  eyebrowText,
  heading
};
export default getTextStyles;